// converte a Date to local time zone (usefull for summer ou winter time diff)
export function setTimeZone(date: Date):Date {
    date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
    return date;
}